import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type {
  UpdateManyCertificateRequestsMutationRequest,
  UpdateManyCertificateRequestsMutationResponse,
} from "../types/UpdateManyCertificateRequests"

type UpdateManyCertificateRequestsClient = typeof client<
  UpdateManyCertificateRequestsMutationResponse,
  Error,
  UpdateManyCertificateRequestsMutationRequest
>
type UpdateManyCertificateRequests = {
  data: UpdateManyCertificateRequestsMutationResponse
  error: Error
  request: UpdateManyCertificateRequestsMutationRequest
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<UpdateManyCertificateRequestsClient>>
  client: {
    parameters: Partial<Parameters<UpdateManyCertificateRequestsClient>[0]>
    return: Awaited<ReturnType<UpdateManyCertificateRequestsClient>>
  }
}
/**
 * @description Update many certificate requests
 * @summary Update many certificate requests
 * @link /v1/certificate-request/update-many-certificate-requests
 */
export function useUpdateManyCertificateRequests(
  options: {
    mutation?: UseMutationOptions<
      UpdateManyCertificateRequests["response"],
      UpdateManyCertificateRequests["error"],
      UpdateManyCertificateRequests["request"]
    >
    client?: UpdateManyCertificateRequests["client"]["parameters"]
  } = {}
): UseMutationResult<
  UpdateManyCertificateRequests["response"],
  UpdateManyCertificateRequests["error"],
  UpdateManyCertificateRequests["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    UpdateManyCertificateRequests["response"],
    UpdateManyCertificateRequests["error"],
    UpdateManyCertificateRequests["request"]
  >({
    mutationFn: async (data) => {
      const res = await client<
        UpdateManyCertificateRequests["data"],
        UpdateManyCertificateRequests["error"],
        UpdateManyCertificateRequests["request"]
      >({
        method: "post",
        url: `/v1/certificate-request/update-many-certificate-requests`,
        data,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
